'use client';

import { type JSX, useState } from 'react';

import MobileNavOverlay from '../mobile/MobileNavOverlay';
import IconAction from '../shared/IconAction';
import { telemetryClickHandler } from '../telemetryHandler';
import type { ActionItemConfig, MobileBottomAction, MobileNavItemConfig } from '../types';

interface TabletNavActionsProps {
    actions: ActionItemConfig[];
    hamburgerNavItems: MobileNavItemConfig[];
    overlayActions: MobileBottomAction[];
    darkHeader?: boolean;
}

export default function TabletNavActions({
    actions,
    hamburgerNavItems,
    overlayActions,
    darkHeader = false,
}: TabletNavActionsProps): JSX.Element {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <>
            <div className="hidden items-center gap-4 lg:flex topnav-xl:hidden">
                {actions.map((item) => {
                    if (item.type === 'link') {
                        return (
                            <a
                                key={item.href}
                                href={item.href}
                                className={`text-base font-normal hover:opacity-80 ${darkHeader ? 'text-white' : 'text-gray-900'}`}
                                onClick={telemetryClickHandler(item.telemetrySlug, item.telemetryEvents)}
                            >
                                {item.label}
                            </a>
                        );
                    }

                    if (item.type === 'cta') {
                        return (
                            <a
                                key={item.href}
                                href={item.href}
                                className="flex h-10 items-center justify-center rounded-[10px] bg-[#ffea6a] px-6 text-sm font-semibold text-gray-900 hover:bg-yellow-500"
                                onClick={telemetryClickHandler(item.telemetrySlug, item.telemetryEvents)}
                            >
                                {item.label}
                            </a>
                        );
                    }

                    return <IconAction key={item.href} item={item} darkHeader={darkHeader} />;
                })}

                <button type="button" onClick={(): void => setIsMenuOpen(true)} aria-label="Open menu">
                    <svg width="24" height="24" viewBox="0 0 16 16" fill="none">
                        <path
                            d="M2 4H14M2 8H14M2 12H14"
                            stroke={darkHeader ? '#FFFFFF' : '#1F2830'}
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
            </div>

            <MobileNavOverlay
                isOpen={isMenuOpen}
                onClose={(): void => setIsMenuOpen(false)}
                navItems={hamburgerNavItems}
                bottomActions={overlayActions}
            />
        </>
    );
}
